const BASE_URL = 'http://98.90.119.41/api';

export default BASE_URL;